import React from "react";

function HoverText({text, isActive, onClick}){

    

    return (<>
    <div className="relative inline-block h-100 cursor-pointer overflow-hidden group"
    onClick={onClick}
    >
                    <span className={`${isActive ? 'font-bold' : 'font-normal'} relative z-10 text-3xl pt-10 pl-8  underline underline-offset-8 decoration-red-500 text-black hover:text-white`}>{text}</span>
                <div className="ml-8 absolute inset-0 bg-red-500 transform translate-y-full  group-hover:translate-y-0 transition-transform duration-500 ease-in-out"></div>
            </div>
            </>)
}
export default HoverText;